import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import InfoBox from "../../common/template/infoBox";
import imagemLampada from "../../assets/images/lampada.png";
import imagemGota from "../../assets/images/gota.png";
import { getLogados } from "../../usuario/usuarioActions";

function CardsTotalizadoresComponent(props) {
    const [totais, setTotais] = useState({
        totalUsuarios: 0,
        logados: 0,
        acessosSemana: 0,
        totalClientes: 0,
        totalUCsEnergia: 0,
        totalUCsAgua: 0,
        unidadesIntegradas: 0,
        unidadesGeradoras: 0,
        unidadesRemotas: 0,
        totalFaturasImportadas: 0,
    });

    useEffect(() => {
        if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) return;

        setTotais({
            totalUsuarios: props.totalUsuarios || 0,
            logados: props.logados || 0,
            acessosSemana: props.acessosSemana || 0,
            totalClientes: props.listaCliente.length || 0,
            totalUCsEnergia: props.listaUnidadeConsumidora.filter((item) => !!item.id_concessionaria).length || 0,
            totalUCsAgua: props.listaUnidadeConsumidora.reduce((acc, atual) => acc + atual.unidades_consumidoras_agua.length, 0) || 0,
            unidadesIntegradas: props.listaUnidadeConsumidora.filter((item) => item.geracao && !item.remota && item.geracao_integracao).length || 0,
            unidadesGeradoras: props.listaUnidadeConsumidora.filter((item) => item.geracao && !item.remota).length || 0,
            unidadesRemotas: props.listaUnidadeConsumidora.filter((item) => item.remota).length || 0,
            totalFaturasImportadas: props.totalFaturasImportadas || 0,
        });
    }, [props.listaCliente, props.listaUnidadeConsumidora, props.totalUsuarios, props.logados, props.acessosSemana, props.totalFaturasImportadas, props.usuarioLogado]);

    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) return null;
    function handleClickUsuariosLogados() {
        props.getLogados({
            callback: () => {
                props.atualizarStatePai({
                    dialogLogados: props.usuarioLogado.acesso_usuario_logado,
                });
            },
            idEmpresa: props.usuarioLogado.id_empresa || props.filtro.id_empresa,
        });
    }

    function handleClickLogaramNaSemana() {
        props.atualizarStatePai({
            dialogLogadosSemana: props.usuarioLogado.acesso_usuario_logado,
        });
    }

    return (
        <Row>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-user" text="Total de Usuários" number={totais.totalUsuarios} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-user-check" text="Usuários Logados" number={totais.logados} hideCheckbox={true} onClick={handleClickUsuariosLogados} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-calendar-check" text="Logaram na Semana" number={totais.acessosSemana} hideCheckbox={true} onClick={handleClickLogaramNaSemana} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-users" text="Total de Clientes" number={totais.totalClientes} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox
                    icon="fas fa-home"
                    text="Total de Unidades Consumidoras"
                    number={
                        <div>
                            <img style={{ marginBottom: 3, marginInline: 5 }} src={imagemLampada} height={15} alt="" />
                            {totais.totalUCsEnergia}
                            {" | "}
                            <img style={{ marginBottom: 3, marginInline: 5 }} src={imagemGota} height={13} alt="" />
                            {totais.totalUCsAgua}
                        </div>
                    }
                />
            </Grid>

            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-solar-panel" text="Total de Sistemas Solares" number={`${totais.unidadesIntegradas} de ${totais.unidadesGeradoras} unidades integradas`} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-network-wired" text="Total de Unidades Remotas" number={totais.unidadesRemotas} />
            </Grid>
            <Grid cols="12 4 3 3">
                <InfoBox icon="fas fa-file-invoice-dollar" text="Total de Faturas Importadas" number={totais.totalFaturasImportadas} />
            </Grid>
        </Row>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    aguardando: state.dashboard.aguardando,
    listaCliente: state.dashboard.listaCliente,
    listaUnidadeConsumidora: state.dashboard.listaUnidadeConsumidora,
    totalFaturasImportadas: state.fatura.totalFaturasImportadas,
    acessosSemana: state.usuario.acessos_semana,
    totalUsuarios: state.usuario.totalUsuarios,
    logados: state.usuario.logados,
    filtro: state.dashboard.filtro,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({ getLogados }, dispatch);
const CardsTotalizadores = connect(mapStateToProps, mapDispatchToProps)(CardsTotalizadoresComponent);
export { CardsTotalizadores };
